module.exports = __webpack_public_path__ + "static/media/mail.c67b91b7.svg";